import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateIsAllNotificationReaded } from '../../redux/notifications/notifications.actions';
import NotificationItem from './NotificationItem';
import { RingingIcon } from '../../assets/icons';
import useTranslation from 'hooks/useTranslation';

const mapState = ({ notificationsData }) => ({
  notifications: notificationsData.notifications,
  isAllNotificationReaded: notificationsData.isAllNotificationReaded,
});

const NotificationsPopover = (props) => {
  const { notifications, isAllNotificationReaded } = useSelector(mapState);
  const dispatch = useDispatch();
  const { getAppLocale } = useTranslation('COMMON');
  const locale = getAppLocale();

  const getNotifText = (notif) => {
    if (locale === 'en') return notif.text_en;

    return notif.text_fa;
  };

  useEffect(() => {
    dispatch(updateIsAllNotificationReaded());
  }, [dispatch]);
  return (
    <>
      <img src={RingingIcon} alt='' />
      {!isAllNotificationReaded && <span className='badge'></span>}
      <div className='primary__menu__bottom__notificatoin__open'>
        <ul className='primary__menu__bottom__notificatoin__open__inner'>
          {notifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              {...notification}
              text={getNotifText(notification)}
            />
          ))}
        </ul>
      </div>
    </>
  );
};

export default NotificationsPopover;
